import { useTranslation } from "react-i18next";
import { Phone, MessageCircle, FileText } from "lucide-react";
import { useLocation } from "react-router-dom";
import { CONTACT } from "../lib/api";
import { trackConversion } from "../lib/gtag";

export default function MobileStickyCTA() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;

  return (
    <div
      data-testid="mobile-sticky-cta"
      className="fixed bottom-0 inset-x-0 z-40 lg:hidden bg-[#0A1128] border-t-2 border-[#FF5A1F] shadow-[0_-8px_20px_rgba(0,0,0,0.2)]"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="grid grid-cols-3">
        <a
          href={`tel:${CONTACT.phone}`}
          data-testid="mcta-call"
          onClick={() => trackConversion("phone_click", { location: "sticky_mobile" })}
          className="flex flex-col items-center justify-center gap-1 py-3 text-white active:bg-white/10 transition-colors"
        >
          <Phone className="w-5 h-5 text-[#FF5A1F]" strokeWidth={2.4} />
          <span className="text-[11px] font-bold uppercase tracking-wider">{t("mobile_cta.call")}</span>
        </a>
        <a
          href={`https://wa.me/${CONTACT.whatsapp}`}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mcta-whatsapp"
          onClick={() => trackConversion("whatsapp_click", { location: "sticky_mobile" })}
          className="flex flex-col items-center justify-center gap-1 py-3 text-white active:bg-white/10 border-x border-white/10 transition-colors"
        >
          <MessageCircle className="w-5 h-5 text-[#FF5A1F]" strokeWidth={2.4} />
          <span className="text-[11px] font-bold uppercase tracking-wider">{t("mobile_cta.whatsapp")}</span>
        </a>
        <a
          href="/#offerte"
          data-testid="mcta-quote"
          className="flex flex-col items-center justify-center gap-1 py-3 bg-[#FF5A1F] text-white active:brightness-90 transition-[filter]"
        >
          <FileText className="w-5 h-5" strokeWidth={2.4} />
          <span className="text-[11px] font-bold uppercase tracking-wider">{t("mobile_cta.quote")}</span>
        </a>
      </div>
    </div>
  );
}
